import React, {useState} from "react";
import { useSelector } from "react-redux";
import {  Grid, Tab, Box,makeStyles } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { InformacionProveedor } from "./InformacionProveedor";
import { DatosContactoProveedor } from "./DatosContactoProveedor";
import { DatosContablesProveedor } from "./DatosContablesProveedor";
import { DocumentacionProveedor } from "./DocumentacionProveedor";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "1rem",
    borderRadius: 5,
  },
}));

export const TabsProveedores = (props) => {
    const classes = useStyles();
    const {esNuevo} = props;
    const {Menu} = props;
    const {proveedorInfo} = useSelector((state) => state.proveedores)
    const {oferente} = useSelector((state) => state.compras)
    //
    const isDisabled = proveedorInfo === null;
    const [value, setValue] = useState("1");

    const handleChange = (event, newValue) => (
      setValue(newValue)
    )

   console.log(Boolean(proveedorInfo?.length > 0 ))

   
    return(
        <>
        {
          Boolean(proveedorInfo !== null || oferente?.cuit) &&
             <Grid className={classes.root}>
             <TabContext value={value}>
             <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
               <TabList onChange={handleChange}>
                 <Tab label="Información" value="1" />
                 <Tab disabled={isDisabled} label="Datos Contacto" value="2"/> 
                 <Tab disabled={isDisabled} label="Datos Contables" value="3"  />
                 <Tab disabled={isDisabled} label="Documentación" value="4" />
               </TabList>
             </Box>
 
             <TabPanel value="1" >
               <InformacionProveedor esNuevo={esNuevo} Menu={Menu} proveedorInfo={proveedorInfo} />
             </TabPanel>
             <TabPanel value="2">
               <DatosContactoProveedor esNuevo={esNuevo} Menu={Menu} />
             </TabPanel>
             <TabPanel value="3">
               <DatosContablesProveedor esNuevo={esNuevo} Menu={Menu} />
             </TabPanel>
             <TabPanel value="4" esNuevo={esNuevo} Menu={Menu}>
               <DocumentacionProveedor />
             </TabPanel>
           </TabContext>
         </Grid>
        }
        </>
            
        
    )


}